import React from "react";
import {BaseContactFormContainer} from "app/contacts/components/BaseContactForm/BaseContactFormContainer";

export const RegistrantEduContactForm = (props) =>
    <BaseContactFormContainer {...props} isRegistrant={true} isEdu={true}/>